import {SingleQuestion} from "pages/Test/components/question/question-types/SingleQuestion";
import {MultipleQuestion} from "pages/Test/components/question/question-types/MultipleQuestion";
import type {Question} from "../../../../config/types";
import {QuestionType} from "../../../../config/types";

type QuestionProps = {
  question: Question;
}

export const BaseQuestion = (props: QuestionProps) => {
  switch (props.question.type) {
    case QuestionType.SINGLE:
      return <SingleQuestion question={props.question}/>;
    case QuestionType.MULTIPLE:
      return <MultipleQuestion question={props.question}/>;
    default:
      return null;
  }
};